import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import {
  elRed,
  textPrimary,
  textInverse,
  headerBackground,
  headerBackgroundDark,
} from 'src/styles/colors';
import {
  LARGE_TABLET_MAX_WIDTH, NARROW_DESKTOP_MAX_WIDTH, WIDE_DESKTOP_MIN_WIDTH
} from 'src/styles/breakpoints';
import { PrimaryButton } from 'src/elements/buttons';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 78px;
  gap: 16px;
  padding: 0 5%;
  z-index: 999999 !important;
  background-color: ${({ $onSalePath }) =>
    $onSalePath ? headerBackgroundDark : headerBackground};
  color: ${({ $onSalePath }) => $onSalePath ? textInverse : textPrimary};
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  height: 100%;

  img {
    height: 60px;
    width: auto;

    @media (max-width: ${NARROW_DESKTOP_MAX_WIDTH}px) {
      height: 48px;
    }
  }
`;

export const LinkContainer = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
  gap: clamp(10px, 1.1vw, 24px);
  font-size: 18px;

  @media (max-width: ${NARROW_DESKTOP_MAX_WIDTH}px) {
    font-size: 16px;
    gap: 8px;
  }

  @media (min-width: ${WIDE_DESKTOP_MIN_WIDTH}px) {
    font-size: 20px;
  }
`;

const activeUnderline = css`
  padding: 4px 0;
  border-bottom: 3px solid ${({ $active }) => $active ? elRed : 'transparent'};
`;

export const NavigationLink = styled(Link)`
  color: ${({ $onSalePath }) => $onSalePath ? textInverse : textPrimary};
  text-decoration: none;
  white-space: nowrap;
  ${activeUnderline}
`;

export const DropdownTriggerLabel = styled.span`
  color: ${({ $onSalePath }) => $onSalePath ? textInverse : textPrimary};
  white-space: nowrap;
  ${activeUnderline}
`;

export const RegisterButton = styled(PrimaryButton)`
  @media (max-width: ${NARROW_DESKTOP_MAX_WIDTH}px) {
    font-size: 15px;
    padding: 10px 14px;
  }
`;

export const FullRegisterLabel = styled.span`
  @media (max-width: ${LARGE_TABLET_MAX_WIDTH}px) {
    display: none;
  }
`;

export const ShortRegisterLabel = styled.span`
  display: none;

  @media (max-width: ${LARGE_TABLET_MAX_WIDTH}px) {
    display: inline;
  }
`;

export const IconButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
`;
